import { render, staticRenderFns } from "./SelectVillageComponent.vue?vue&type=template&id=799cb4dd&scoped=true&"
import script from "./SelectVillageComponent.vue?vue&type=script&lang=js&"
export * from "./SelectVillageComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "799cb4dd",
  null
  
)

export default component.exports